import { ArrowLeft, Search, Settings, X } from "lucide-react";
import { useFranklinContext } from "../../context/franklin-context";

export function SidebarHeader() {
  const { close } = useFranklinContext();

  return (
    <div
      className="flex h-16 items-center justify-between border-b px-6"
      style={{
        borderColor: "rgba(0, 0, 0, 0.06)",
        backgroundColor: "var(--franklin-surface)",
      }}
    >
      <button
        className="flex h-9 items-center gap-2 rounded-lg px-3 font-normal text-sm transition-colors hover:bg-gray-50"
        onClick={close}
        style={{
          color: "#6B7280",
        }}
        type="button"
      >
        <ArrowLeft className="h-4 w-4" strokeWidth={1.5} />
        <span>Back to App</span>
      </button>

      <div className="flex items-center gap-1">
        <button
          className="flex h-9 w-9 items-center justify-center rounded-lg transition-colors hover:bg-gray-50"
          style={{ color: "#9CA3AF" }}
          title="Search"
          type="button"
        >
          <Search className="h-[18px] w-[18px]" strokeWidth={1.5} />
        </button>
        <button
          className="flex h-9 w-9 items-center justify-center rounded-lg transition-colors hover:bg-gray-50"
          style={{ color: "#9CA3AF" }}
          title="Settings"
          type="button"
        >
          <Settings className="h-[18px] w-[18px]" strokeWidth={1.5} />
        </button>
        <button
          className="flex h-9 w-9 items-center justify-center rounded-lg transition-colors hover:bg-gray-50"
          onClick={close}
          style={{ color: "#9CA3AF" }}
          title="Close"
          type="button"
        >
          <X className="h-[18px] w-[18px]" strokeWidth={1.5} />
        </button>
      </div>
    </div>
  );
}
